export default "__VITE_ASSET__bce692f6__"